<template>
  <side-bar
    :sections="sections"
    @open="setSideOpen"
    @close="setSideClosed"
    ref="sidebar"
    noExitButton="true"
    origin="GrooveBlog"
    logo="GrooveBlogLogo"
  >
    <template slot="Navigation">
      <div>
        <Navigation />
      </div>
    </template>
    <template slot="header">
      <div class="flex flex-col">
        <div>GrooveBlog</div>
      </div>
    </template>
  </side-bar>
</template>

<script>
import SideBar from '@groovepages/gd-ui-kit/components/SideBarNew';
import HomeIcon from '@/assets/images/icons/Home.svg';

export default {
  name: 'BlogSidebarMenu',
  data() {
    return {};
  },
  created() {},
  methods: {
    setSideOpen(side) {
      if (side === 'Blogs') {
        this.sendToBlog();
      }
      this.currentOpenMenuItem = side;
    },
    setSideClosed() {
      this.currentOpenMenuItem = '';
    },
    sendToBlog() {
      this.$router.push({ name: 'blog' });
    },
  },
  computed: {
    sections() {
      const sections = [
        { name: 'Blogs', icon: HomeIcon, doNotOpen: 1 },
      ];
      return sections;
    },
  },
  components: {
    SideBar,
  },
};
</script>
